<ng-container [ngSwitch]="type">
    <label class="status status-eta-update"
           *ngSwitchCase="EventType.ETA_UPDATE">
           <i class="fa fa-circle"></i>
        <span [i18n]="'webhooks-events.type.eta-update'"></span>
    </label>
    <label class="status status-pgi"
           *ngSwitchCase="EventType.PGI">
        <i class="fa fa-circle"></i>
        <span [i18n]="'webhooks-events.type.pgi'"></span>
    </label>
    <label class="status status-checkout"
           *ngSwitchCase="EventType.CHECKOUT">
        <i class="fa fa-sign-out-alt"></i>
        <span [i18n]="'webhooks-events.type.checkout'"></span>
    </label>
    <label class="status status-checkin"
           *ngSwitchCase="EventType.CHECKIN">
        <i class="fa fa-sign-in-alt"></i>
        <span [i18n]="'webhooks-events.type.checkin'"></span>
    </label>
    <label class="status status-bol"
           *ngSwitchCase="EventType.BOL_UPDATE">
        <i class="fa fa-circle"></i>
        <span [i18n]="'webhooks-events.type.bol-update'"></span>
    </label>
    <label class="status status-trip-create"
           *ngSwitchCase="EventType.TRIP_CREATE">
        <i class="fa fa-circle"></i>
        <span [i18n]="'webhooks-events.type.trip-create'"></span>
    </label>
    <label class="status status-trip-patch"
           *ngSwitchCase="EventType.TRIP_PATCH">
        <i class="fa fa-circle"></i>
        <span [i18n]="'webhooks-events.type.trip-patch'"></span>
    </label>
    <label class="status status-trip-update"
           *ngSwitchCase="EventType.TRIP_UPDATE">
        <i class="fa fa-circle"></i>
        <span [i18n]="'webhooks-events.type.trip-update'"></span>
    </label>
    <label class="status status-trip-closed"
           *ngSwitchCase="EventType.TRIP_CLOSED">
        <i class="fa fa-circle"></i>
        <span [i18n]="'webhooks-events.type.trip-closed'"></span>
    </label>
    <label class="status status-trip-cancel"
           *ngSwitchCase="EventType.TRIP_CANCEL">
        <i class="fa fa-circle"></i>
        <span [i18n]="'webhooks-events.type.trip-cancel'"></span>
    </label>
    <label class="status status-failed-collection"
           *ngSwitchCase="EventType.FAILED_COLLECTION">
        <i class="fa fa-circle"></i>
        <span [i18n]="'webhooks-events.type.failed-collection'"></span>
    </label>
    <label class="status status-reverse-checkin"
           *ngSwitchCase="EventType.REVERSE_CHECKIN">
        <i class="fa fa-circle"></i>
        <span [i18n]="'webhooks-events.type.reverse-checkin'"></span>
    </label>
    <label class="status"
           *ngSwitchDefault>
        <i class="fa fa-question-circle"></i>
        <span [i18n]="'webhooks-events.type.unknown'"></span>
    </label>
</ng-container>
